module.exports = __webpack_public_path__ + "statics/img/1-3.278ff41.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/imgs/product/icon/1-3.png
// module id = EyJ8
// module chunks = 1